var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.6256C0 33.8119 8.12438 43.1138 18.75 45V28.7494H13.125V22.5H18.75V17.4994C18.75 11.8744 22.3744 8.75062 27.5006 8.75062C29.1244 8.75062 30.8756 9 32.4994 9.24938V15H29.625C26.8744 15 26.25 16.3744 26.25 18.1256V22.5H32.25L31.2506 28.7494H26.25V45C36.8756 43.1138 45 33.8138 45 22.6256C45 10.1813 34.875 0 22.5 0C10.125 0 0 10.1813 0 22.6256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.80fd5c7de7e858ab60ff7f441aa7cf34.svg";
export { ForwardRef as ReactComponent };